import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { ModulosService } from 'src/app/services/modulos.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { BloqueoModulo } from 'src/app/shared/object/bloqueo-vista.Interface';
import { modulo } from 'src/app/shared/object/modulo.model';
import { usuario } from 'src/app/shared/object/usuario.model';
import { BloqueoModuloService } from 'src/app/shared/services/bloqueo-modulo.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import Swal from 'sweetalert2';

@Component({
  templateUrl: './bloqueo-modulo-activo.component.html',
  styleUrls: ['./bloqueo-modulo-activo.component.scss']
})
export class BloqueoModuloActivoComponent implements OnInit {

  formFiltro: FormGroup;
  bloqueos: BloqueoModulo[];
  rut_empresa: number;

  optionModulos: any[];
  optionUsuarios: any[];

  constructor(
    private fb: FormBuilder,
    private bloqueoModuloService: BloqueoModuloService,
    private usuarioService: UsuarioService,
    private moduloServuce: ModulosService,
    private toastService: ToastService,
    private validadoreService: ValidadoresService,
    private accesoLocalstorage: SecurityService,
  ) {
    this.bloqueos = [];
    this.optionModulos = [];
    this.optionUsuarios = [];
    this.rut_empresa = Number(this.accesoLocalstorage.getRutEmpresa());
  }

  get ctrlRutUsuario(): FormControl | undefined {
    return this.formFiltro.get('rutUsuario') as FormControl;
  }

  get ctrlCodigoModulo(): FormControl | undefined {
    return this.formFiltro.get('codigoModulo') as FormControl;
  }

  ngOnInit() {
    this.configurarForm();
    this.obtenerUsuarios();
    this.obtenerModulos();
    this.buscar();
  }

  configurarForm() {
    this.formFiltro = this.fb.group({
      rutUsuario: [null],
      codigoModulo: [null],
    })
  }

  buscar() {
    const inputParams = {
      rutUsuario: this.ctrlRutUsuario.value ? this.ctrlRutUsuario.value : -1,
      codigoModulo: this.ctrlCodigoModulo.value ? this.ctrlCodigoModulo.value : -1,
    }
    console.log(inputParams);
    this.obtenerBloqueos(inputParams);
  }

  limpiarFiltros(): void {
    this.formFiltro.reset({
      rutUsuario: null,
      codigoModulo: null,
    });
    this.buscar();
  }

  obtenerBloqueos(inputParams: {
    rutUsuario: number;
    codigoModulo: number;
  }) {
    this.bloqueoModuloService.obtenerTodosLosBloqueos(inputParams).subscribe(bloqueos => {
      console.log(bloqueos);
      if (bloqueos.some(bloqueo => !bloqueo.exito)) {
        this.bloqueos = [];
        return;
      }
      this.bloqueos = bloqueos.map(b => ({
        ...b,
        rutFormato: this.validadoreService._enmascaraRut(b.rut_usuario.toString()),
        fecha_expiracion: this.obtenerFechaUTCtoDate(b.fecha_expiracion),
        fecha_ultima_actividad: this.obtenerFechaUTCtoDate(b.fecha_ultima_actividad),
      }));
    })
  }

  obtenerUsuarios() {
    const inputParams = {
      entidad: {
        rut_usuario: 0,
        login: '',
        password: '',
        fecha_creacion: new Date(),
        fecha_modificacion: new Date(),
        mail: '',
        activo: true,
        nombre_completo: "",
        flag_cambioclave: true
      },
      rut_empresa: this.rut_empresa,
      roles_codigo: [],
      sucursal_codigo: []
    };

    this.usuarioService.obtenerUsuariosxEmpresa(inputParams, ({ mensajes, respuesta }) => {
      if (respuesta === null || respuesta.registros.length === 0) return;

      this.optionUsuarios = (respuesta.registros as usuario[]).filter(u => u.activo)
      .map(usuario => ({
        value: usuario.rut_usuario,
        label: usuario.nombre_completo.toUpperCase(),
      }));
    })
  }

  obtenerModulos() {
    const inputParams =
    {
      entidad: {
        nombre: "",
      },
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1
    }
    this.moduloServuce.obtenerModulosSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      console.log('modulos', respuesta);
      if (respuesta === null || respuesta.registros.length === 0) return;

      this.optionModulos = (respuesta.registros as modulo[]).filter(modulo => modulo.habilitar_bloqueo)
        .map(modulo => ({
          value: modulo.codigo,
          label: modulo.nombre.toUpperCase()
        }));
    })
  }

  validarEliminar(bloqueo: BloqueoModulo) {
    Swal.fire({
      title: '¿Estás seguro?',
      text: `Se eliminará el bloqueo para el módulo ${bloqueo.nombreModulo}, usuario ${bloqueo.nombreUsuario}.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.eliminarBloqueo(bloqueo);
      }
    });
  }

  eliminarBloqueo(bloqueo: BloqueoModulo) {
    this.bloqueoModuloService.liberarBloqueo(bloqueo.codigo_modulo, bloqueo.rut_usuario).subscribe(res => {
      if (res.exito) {
        this.toastService.success('El bloqueo ha sido eliminado correctamente.');
        this.buscar();
      } else {
        this.toastService.error(`Error al eliminar el bloqueo: ${res.mensajeError}`);
      }
    })
  }

  private obtenerFechaUTCtoDate(fechaUTC: string): string {
    const fecha = fechaUTC.endsWith('Z') ? fechaUTC : fechaUTC + 'Z';
    return fecha;
  }

}
